import { Injectable } from '@angular/core';
import { HotToastService, ToastConfig } from '@ngxpert/hot-toast';
import { ConfigurationModels } from '@wz-models';
import { ToastComponent } from '@wz-tunnelsante/components/toaster/toast.component';
import { DataToastType } from '@wz-tunnelsante/components/toaster/toast.interface';
import { ErrorModels } from 'models/error.model';
import { ResourcesService } from './resources/resources.service';

@Injectable({
  providedIn: 'root',
})
export class InteractionService {
  configToast: ToastConfig;

  constructor(
    private HotToastService: HotToastService,
    private resourceService: ResourcesService,
    private config: ConfigurationModels.Configuration,
  ) {
    this.configToast = config.toasterConfig;
  }

  showSuccess(title: string, description: string) {
    // this.HotToastService.pop(
    //   'success',
    //   this.resourceService.getResource(title),
    //   this.resourceService.getResource(description),
    // );

    this.HotToastService.show<DataToastType>(ToastComponent, {
      ...this.configToast,
      data: {
        pathIcon: 'success',
        textTitle: this.resourceService.getResource(title),
        textBody: this.resourceService.getResource(description),
      },
    });
  }

  showError(descr: string | ErrorModels.TunnelSanteError): any;
  showError(title: string, message: string | ErrorModels.TunnelSanteError): any;
  showError() {
    let title = 'Erreur';
    let descr = arguments[0];
    if (arguments.length === 2) {
      title = arguments[0];
      descr = arguments[1];
    }

    let msg: string;
    if (typeof descr === 'string') {
      msg = this.resourceService.getResource(descr);
    } else {
      msg = descr.appMessage;
      if (descr.apiMessage) {
        msg += ' [' + descr.apiMessage + ']';
      }
    }

    this.HotToastService.show<DataToastType>(ToastComponent, {
      data: {
        pathIcon: 'warning',
        textTitle: title,
        textBody: msg,
      },
      style: {
        border: '1px solid #c21704ff',
        background: '#c21704ff',
        padding: '5px',
        color: 'white',
      },
    });

    //this.HotToastService.pop('error', title, msg);
  }

  showWarning(title: string, description: string) {
    this.HotToastService.show<DataToastType>(ToastComponent, {
      data: {
        pathIcon: 'warning',
        textTitle: this.resourceService.getResource(title),
        textBody: this.resourceService.getResource(description),
      },
      style: {
        border: '1px solid #bba015ff',
        background: '#bba015ff',
        padding: '5px',
        color: 'white',
      },
    });
    // this.HotToastService.pop(
    //   'warning',
    //   this.resourceService.getResource(title),
    //   this.resourceService.getResource(description),
    // );
  }

  showInfo(title: string, description: string) {
    this.HotToastService.show<DataToastType>(ToastComponent, {
      data: {
        pathIcon: 'info',
        textTitle: this.resourceService.getResource(title),
        textBody: this.resourceService.getResource(description),
      },
      style: {
        border: '1px solid #29a936ff',
        background: '#29a936ff',
        padding: '5px',
        color: 'white',
      },
    });
    // this.HotToastService.pop(
    //   'info',
    //   this.resourceService.getResource(title),
    //   this.resourceService.getResource(description),
    // );
  }

  showPrimary(title: string, description: string) {
    // this.HotToastService.pop(
    //   'primary',
    //   this.resourceService.getResource(title),
    //   this.resourceService.getResource(description)
    // );
  }
}
